// extracted by mini-css-extract-plugin
export default {"video":"IframeEmbed_video__HCCBL","iframe":"IframeEmbed_iframe__bW6Vh"};